export type NativeTimedSpeechSegment = {
  text: string;
  start_uptime_ms: number;
  end_uptime_ms: number;
};

export type TimedSpeechSegment = {
  text: string;
  start_ms: number;
  end_ms: number;
};

const MAX_SEGMENTS = 96;

export function rebaseTimedSpeechSegments(
  segments: NativeTimedSpeechSegment[] | undefined,
  originUptimeMs: number | null,
  maxSegments = MAX_SEGMENTS,
): TimedSpeechSegment[] {
  if (
    !segments ||
    originUptimeMs === null ||
    !Number.isFinite(originUptimeMs)
  ) {
    return [];
  }
  return segments.slice(-maxSegments).flatMap((segment) => {
    const text = segment.text?.trim().slice(0, 500);
    const startMs = Math.max(
      0,
      Math.round(segment.start_uptime_ms - originUptimeMs),
    );
    const endMs = Math.max(
      startMs,
      Math.round(segment.end_uptime_ms - originUptimeMs),
    );
    if (
      !text ||
      !Number.isFinite(segment.start_uptime_ms) ||
      !Number.isFinite(segment.end_uptime_ms) ||
      segment.end_uptime_ms < segment.start_uptime_ms
    ) {
      return [];
    }
    return [{ text, start_ms: startMs, end_ms: endMs }];
  });
}
